import React from "react";
import "./button.scss";

function Button({ name = "", handleClick = () => {}, className, img ,id, disabled = false}) {
  return (
    <button id={id} disabled={disabled} className={className ? className : "button-theme p-2 rounded-3xl"} onClick={handleClick}>
      {img && <img src={img} /> }
      <span>{name}</span>
    </button>
  );
}

export default Button;
